import React from 'react';
import { bool, object } from 'prop-types';
import loadable from '@loadable/component';
import { propTypes } from '../../util/types';
import { H1 } from '../PageBuilder/Primitives/Heading';
import { fallbackSections } from './FallbackPage';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

const RefundAndReturnPolicyContent = props => {
  const { inProgress, error, data } = props;

  if (inProgress) {
    return null;
  }

  const hasContent = data => typeof data?.content === 'string';
  const exposeContentAsChildren = data => {
    return hasContent(data) ? { children: data.content } : {};
  };
  const CustomHeading1 = props => <H1 as="h2" {...props} />;

  const hasData = error === null && data;
  const sectionsData = hasData ? data : fallbackSections;

  return (
    <SectionBuilder
      {...sectionsData}
      options={{
        fieldComponents: {
          heading1: { component: CustomHeading1, pickValidProps: exposeContentAsChildren },
        },
        isInsideContainer: true,
      }}
    />
  );
};

RefundAndReturnPolicyContent.defaultProps = {
  inProgress: false,
  error: null,
  data: null,
};

RefundAndReturnPolicyContent.propTypes = {
  inProgress: bool,
  error: propTypes.error,
  data: object,
};

export const ASSET_NAME = 'refund-and-return-policy';
export default RefundAndReturnPolicyContent;
